import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersquisaService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  listarNotas(): Observable<any>{
    const url = `${this.baseUrl}notas`;
    return this.http.get<any>(url)
  }

  criarPesquisa(corpo: any): Observable<any>{
    const url = `${this.baseUrl}criarPesquisa`;
    return this.http.post<any>(url, corpo)
  }
  
  listarPesquisas(): Observable<any>{
    const url = `${this.baseUrl}listarPesquisas`;
    return this.http.get<any>(url)
  }

  desativarPesquisas(idPesquisa: any): Observable<any>{
    const url = `${this.baseUrl}desativarPesquisa/${idPesquisa}`;
    return this.http.delete<any>(url)
  }
}
